import { render, staticRenderFns } from "./imprRate.vue?vue&type=template&id=8a1c55c6"
import script from "./imprRate.vue?vue&type=script&lang=js"
export * from "./imprRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a1c55c6')) {
      api.createRecord('8a1c55c6', component.options)
    } else {
      api.reload('8a1c55c6', component.options)
    }
    module.hot.accept("./imprRate.vue?vue&type=template&id=8a1c55c6", function () {
      api.rerender('8a1c55c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main/impr/imprRate.vue"
export default component.exports